(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[704],{

/***/ "PITM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PeopleDouble", function() { return PeopleDouble; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var PeopleDouble = function PeopleDouble(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    fillRule: "evenodd",
    d: "M22 14.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-.7 3.78a4 4 0 0 1-2.6 0A1 1 0 0 1 18 20c-.54 0-.9.15-1.18.37-.3.23-.55.6-.78 1.1a9.79 9.79 0 0 0-.58 1.78l-.2.8-.3 1.21a1 1 0 0 1-1.93-.52l.27-1.08.22-.9c.17-.7.39-1.43.7-2.11.3-.68.73-1.35 1.36-1.85a3.78 3.78 0 0 1 2.48-.8 4 4 0 1 1 3.87 0H22c.96 0 1.76.29 2.41.8.63.5 1.06 1.17 1.37 1.85.3.68.52 1.42.7 2.11l.21.9.27 1.08a1 1 0 1 1-1.93.52l-.3-1.2-.2-.8c-.16-.67-.34-1.27-.57-1.78-.24-.51-.5-.88-.79-1.11A1.79 1.79 0 0 0 22 20a1 1 0 0 1-.7-1.72Z",
    clipRule: "evenodd"
  }), __jsx("path", {
    fillRule: "evenodd",
    d: "M16 9.25a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-1.76 4.84a5.01 5.01 0 0 1-2.49 0 1 1 0 0 1-.75 1.66c-1 0-1.54.07-1.9.21-.27.12-.5.31-.77.85-.3.58-.57 1.45-.94 2.82l-.43 1.65c-.28 1.06-.6 2.3-1 3.74a1 1 0 1 1-1.93-.54c.4-1.42.71-2.62.98-3.67l.45-1.7c.37-1.35.69-2.41 1.08-3.2.42-.84.97-1.45 1.8-1.8a6.82 6.82 0 0 1 2.48-.36 5 5 0 1 1 6.72-2.4c-.56.43-1 1-1.26 1.67a5 5 0 0 1-1.1.73c.3 0 .6.01.88.03a4.02 4.02 0 0 0 .15 2.03c-.3-.04-.7-.06-1.21-.06a1 1 0 0 1-.76-1.66Z",
    clipRule: "evenodd"
  }));
};

/***/ })

}]);